export class ColorHelper {
	public static generateSimilarColor(baseColor: string, variationStrength: number = 30): string {
		// RGB-String zu Objekt konvertieren
		const parseColor = (color: string): { r: number; g: number; b: number } | null => {
			// Hex-Format
			const hexMatch = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color);
			if (hexMatch) {
				return {
					r: Number.parseInt(hexMatch[1], 16),
					g: Number.parseInt(hexMatch[2], 16),
					b: Number.parseInt(hexMatch[3], 16),
				};
			}

			// RGB-Format
			const rgbMatch = /^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/i.exec(color);
			if (rgbMatch) {
				return {
					r: Number.parseInt(rgbMatch[1]),
					g: Number.parseInt(rgbMatch[2]),
					b: Number.parseInt(rgbMatch[3]),
				};
			}

			// Einfaches Komma-separiertes Format: "219,0,49"
			const simpleMatch = /^(\d+),\s*(\d+),\s*(\d+)$/.exec(color);
			if (simpleMatch) {
				return {
					r: Number.parseInt(simpleMatch[1]),
					g: Number.parseInt(simpleMatch[2]),
					b: Number.parseInt(simpleMatch[3]),
				};
			}

			return null;
		};

		const rgb = parseColor(baseColor);
		if (!rgb) return baseColor;

		const randomVariation = () => Math.floor(Math.random() * (variationStrength * 2 + 1)) - variationStrength;

		const r = Math.max(0, Math.min(255, rgb.r + randomVariation()));
		const g = Math.max(0, Math.min(255, rgb.g + randomVariation()));
		const b = Math.max(0, Math.min(255, rgb.b + randomVariation()));

		return this.rgbToHex(r, g, b);
	}

	public static rgbToHex(r: number, g: number, b: number): string {
		const toHex = (value: number): string => {
			const hex = value.toString(16);
			return hex.length === 1 ? '0' + hex : hex;
		};

		return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
	}

	public static rgbStringToHex(rgb: string): string {
		const [r, g, b] = rgb.split(',').map(Number);
		return this.rgbToHex(r, g, b);
	}

	/**
	 * Konvertiert Hex-Farbe zu RGB-String für rgba() Nutzung
	 * @param hex - Hex-Farbwert (mit oder ohne #)
	 * @param fallback - Fallback RGB-String (default: '200, 200, 200')
	 * @returns RGB-String im Format "r, g, b"
	 */
	public static hexToRgb(hex: string, fallback: string = '200, 200, 200'): string {
		if (!hex) {
			return fallback;
		}
		hex = hex.replace('#', '');

		const result = /^([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
		return result ? `${Number.parseInt(result[1], 16)}, ${Number.parseInt(result[2], 16)}, ${Number.parseInt(result[3], 16)}` : fallback;
	}
}
